import hotImg from '../assets/hot.png';
import { List, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import unit from '../unit';

// 新增：路径参数与数字的映射关系
const typeMap = {
  'institution': 1,
  'niusan': 2,
  'fund': 3,
  'nationalteam': 4,
  'foreigncapital': 5
};

// 热搜榜
const HotSideBar = (props) => {
    const navigate = useNavigate();
    const [name, setName] = useState('机构');
    const [hotSource, setHotSource] = useState([]);

    const getSourceList = (type) => {
        // 将路径参数转换为数字类型
        const numericType = typeMap[type];
        
        const path = '/pc/gudong/getHotSearch';
        unit.httpGet(path, { "type": numericType }, (data) => {
            setName(data.name);
            if (data.list.length > 0) {
                let _hotSource = [];
                for (let i = 0; i < data.list.length; i++) {
                    let tmp = {};
                    tmp['index'] = i;
                    tmp['code'] = data.list[i].code;
                    tmp['name'] = data.list[i].name;
                    _hotSource.push(tmp);
                }
                setHotSource(_hotSource);
            }
        });
    };

    useEffect(() => {
        const type = props.type;
        getSourceList(type);
    }, [props.type]); // 监听 props.type 的变化

    return (
        <div className='content-block'>
            <div className='block-title' style={{ background: "linear-gradient( 180deg, #FFE6E6 0%, #FFFFFF 100%)" }}>
                <img className='title-icon' src={hotImg} /> <span style={{ verticalAlign: 'middle' }}>{name}热搜榜</span>
            </div>
            {props.type === 'niusan' ? ( // 修改：使用新的路径参数值
                <Row gutter={16}>
                    <Col span={12}>
                        <List
                            itemLayout="horizontal"
                            size="small"
                            split={false}
                            locale={{emptyText: "暂无数据" }} 
                            dataSource={hotSource.filter((_, index) => index % 2 === 0)} 
                            renderItem={(item, index) => (
                                <List.Item>
                                    <div>
                                        <span className={unit.getTextClassName(index * 2)}>{index * 2 + 1}</span>
                                        <a href={`/detail/${item.code}`} style={{ color: "#333333" }}>{item.name}</a>
                                    </div>
                                </List.Item>
                            )}
                        />
                    </Col>
                    <Col span={12}>
                        <List
                            itemLayout="horizontal"
                            size="small"
                            split={false}
                            locale={{emptyText: "暂无数据" }} 
                            dataSource={hotSource.filter((_, index) => index % 2 !== 0)}
                            renderItem={(item, index) => (
                                <List.Item >
                                    <div>
                                        <span className={unit.getTextClassName(index * 2 + 1)}>{index * 2 + 2}</span>
                                        <a href={`/detail/${item.code}`} style={{ color: "#333333" }} >{item.name}</a>
                                    </div>
                                </List.Item>
                            )}
                        />
                    </Col>
                </Row>
            ) : (
                <List
                    itemLayout="horizontal"
                    size="small"
                    locale={{emptyText: "暂无数据" }} 
                    split={false}
                    dataSource={hotSource}
                    renderItem={(item, index) => (
                        <List.Item >
                            <div>
                                <span className={unit.getTextClassName(index)}>{index + 1}</span>
                                <a href={`/detail/${item.code}`} style={{ color: "#333333" }}>{item.name}</a>
                            </div>
                        </List.Item>
                    )}
                />
            )}
        </div>
    );
};

export default HotSideBar;